import { EluveError } from '@eluve/eluve-errors';

/**
 * The tenant-token mint endpoint rejected the request because the user is not
 * a member of the requested tenant (403). Maps to the session machine's
 * TenantSwitchFailed state — the same UX as a rejected legacy tenant switch.
 */
export class TenantTokenMintForbiddenError extends EluveError {
  static override readonly errorName = 'TenantTokenMintForbiddenError';
  readonly logLevel = 'warn' as const;

  constructor(message = 'Not a member of the requested tenant') {
    super(message);
  }
}

/**
 * The tenant-token mint endpoint does not exist on the backend serving this
 * request (404) — an old api-nest during a rollback/rollout window. The
 * session machine falls back to the legacy shared-session switch flow.
 * Remove together with the createTenantSession fallback. [ENG-5545]
 */
export class TenantTokenMintUnavailableError extends EluveError {
  static override readonly errorName = 'TenantTokenMintUnavailableError';
  readonly logLevel = 'warn' as const;

  constructor(message = 'Tenant token endpoint unavailable') {
    super(message);
  }
}
